// extracted by mini-css-extract-plugin
export var cost = "style-module--cost--edcea";
export var costBtn = "style-module--cost-btn--c2255";
export var cost__rf = "style-module--cost__rf--f2b24";
export var cost_wrapper = "style-module--cost_wrapper--49e87";
export var cost_wrapperBottom = "style-module--cost_wrapper-bottom--f53fc";
export var cost_wrapperBottom_desc = "style-module--cost_wrapper-bottom_desc--941c7";
export var cost_wrapperTop = "style-module--cost_wrapper-top--596c4";
export var cost_wrapperTop_desc = "style-module--cost_wrapper-top_desc--f10f3";
export var cost_wrapperTop_suptitle = "style-module--cost_wrapper-top_suptitle--5e393";
export var cost_wrapperTop_title = "style-module--cost_wrapper-top_title--6ad26";
export var newCost = "style-module--new-cost--e278f";
export var oldCost = "style-module--old-cost--f44e2";